import React from 'react';

// Horizontal scroll box for wide tables. The table's own scrollbar shows at
// its end only when it is actually wider than the box; while the list runs on
// below the screen, StickyHScrollbar (mounted once in Layout) pins a slider to
// the bottom of the screen for it — the same behavior as the LMS tables.
const FloatingScrollWrapper = ({ children, style, innerClassName, innerStyle }) => (
  <div style={{ position: 'relative', ...style }}>
    <div
      className={`fsw-inner${innerClassName ? ` ${innerClassName}` : ''}`}
      style={{ overflowX: 'auto', overflowY: 'visible', ...innerStyle }}
    >
      {children}
    </div>
  </div>
);

export default FloatingScrollWrapper;
